import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QuizService } from 'src/app/services/quiz.service';
import { CoursesService } from 'src/app/services/courses.service';
import { PDFDocument } from 'pdf-lib'
import { FileHelper } from 'src/app/helpers';
import { QuizQuestion } from 'src/app/models';

@Component({
  selector: 'app-module2-rw',
  templateUrl: './module2-rw.component.html',
  styleUrls: ['./module2-rw.component.css', '../rentwise.component.css']
})
export class Module2RwComponent implements OnInit {

  module = 2;
  page = 1;

  pdfHandoutFillable1!: PDFDocument;
  pdfKey1!: PDFDocument;

  pdfHandoutFillable2!: PDFDocument;
  pdfKey2!: PDFDocument;

  pdfHandoutFillable4!: PDFDocument;

  // Contains all questions for the module
  questions: QuizQuestion[] = [];

  constructor(private courseService: CoursesService, private router: Router, private quizService: QuizService) { }

  async ngOnInit(): Promise<void> {
    this.courseService.setCurrentCourseBy('RentWise');

    // Open the furthest page
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      this.page = this.courseService.currentCourse.furthestPageID + 1;
    }

    // Get the questions for this module and assign them to this.questions
    this.quizService.getModuleQuizzes("61f342f0fadf713839b08cda").toPromise().then((res: any) => {
      this.quizService.moduleQuizQuestions = res.docs;
      this.questions = this.quizService.moduleQuizQuestions;
    });

    const handoutFillablePdfBytes1 = await fetch("../../../../../assets/RWM2A1HandoutFillable.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable1 = await PDFDocument.load(handoutFillablePdfBytes1);
    const keyPdfBytes1 = await fetch("../../../../../assets/RWM2A1Key.pdf").then(res => res.arrayBuffer());
    this.pdfKey1 = await PDFDocument.load(keyPdfBytes1);

    const handoutFillablePdfBytes2 = await fetch("../../../../../assets/RWM2A2HandoutFillable.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable2 = await PDFDocument.load(handoutFillablePdfBytes2);
    const keyPdfBytes2 = await fetch("../../../../../assets/RWM2A2Key.pdf").then(res => res.arrayBuffer());
    this.pdfKey2 = await PDFDocument.load(keyPdfBytes2);

    const handoutFillablePdfBytes4 = await fetch("../../../../../assets/RWM2A4Handout.pdf").then(res => res.arrayBuffer());
    this.pdfHandoutFillable4 = await PDFDocument.load(handoutFillablePdfBytes4);

  }



  // Update furthestModuleID
  updateProgress() {
    if (this.courseService.currentCourse.furthestModuleID < this.module) {
      this.courseService.updateFurthestModule().toPromise().then((res: any) => {
        console.log(res);
      });
    }
  }

  // Update furthestPageID
  updatePageProgress() {
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      if (this.courseService.currentCourse.furthestPageID < this.page) {
        this.courseService.updateFurthestPage(this.page).toPromise();
      }
    }
  }

  // Handle the quiz results, allow them to pass or not
  handleQuiz(valueEmitted: boolean){

    // Quiz passed
    if (valueEmitted) {
      this.updateProgress();
      this.router.navigate(['/module3-rw']);
    }

    // Review
    else {
      this.page = 1
    }
  }

  next(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.page += 1;
    window.scrollTo(0,0);
    this.updatePageProgress();
    return true;
  }

  back(){
    this.page -= 1;
    window.scrollTo(0,0);
    return true;
  }

  async downloadHandoutFillablePdf1 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable1.save();
    FileHelper.saveByteArray('RWM2A1HandoutFillable.pdf', pdfBytes, 'application/pdf');
  }
  async downloadKeyPdf1 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfKey1.save();
    FileHelper.saveByteArray('RWM2A1Key.pdf', pdfBytes, 'application/pdf');
  }

  async downloadHandoutFillablePdf2 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable2.save();
    FileHelper.saveByteArray('RWM2A2HandoutFillable.pdf', pdfBytes, 'application/pdf');
  }
  async downloadKeyPdf2 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfKey2.save();
    FileHelper.saveByteArray('RWM2A2Key.pdf', pdfBytes, 'application/pdf');
  }

  async downloadHandoutFillablePdf4 () {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandoutFillable4.save();
    FileHelper.saveByteArray('RWM2A4HandoutFillable.pdf', pdfBytes, 'application/pdf');
  }

  all<T = unknown>(array: T[], value: T) {
    return array.every(v => v === value);
  }

  allOf(obj: Object, value = true) {
    return this.all(Object.values(obj), value);
  }
}
